<template>
	<div class="animated fadeIn">

		<div class="row mb10">
			<div class="col-xs-12 clearfix">

				<div class="pull-left f24">
					<i class="fa fa-fire text-success"></i>
					<span>{{name}}列表</span>
				</div>
				<div class="pull-right">
					<button class="btn btn-primary" @click.stop.prevent="$router.push('/cgd/by/article/create')">
						<i class="fa fa-send"></i>
						<span>发布{{name}}</span>
					</button>
				</div>
			</div>
		</div>

		<div class="row">

			<div class="col-xs-12">
				<NbFilter :pager="pager" :callback="search"></NbFilter>
			</div>


			<div class="col-xs-12">
				<div v-for="article in pager.articles" class="bg-white p10 mt10 border-radius-4"
				>

					<div class="media">
						<div class="pull-left" v-if="false">
							<img class="img-rounded img-md" v-if="article.poster && article.poster.url" :src="article.poster.url">
						</div>

						<div class="pull-right action-buttons">
							<a title="编辑" @click.stop.prevent="$router.push('/cgd/by/article/edit/'+article.id)">
								<i class="fa fa-pencil text-info f20"></i>
							</a>
							<a href="javascript:void(0)" title="删除" v-if="article.type !== 'WEBSITE'"
							   @click.stop.prevent="confirmDel(article)">
								<i class="fa fa-trash text-danger f20"></i>
							</a>
						</div>
						<div class="media-body">
							<div>
								<span class="label" :class="'label-'+article.getTypeStyle()">{{article.getTypeName()}}</span>
								<span class="f15 nb-a" @click.stop.prevent="$router.push('/cgd/by/article/detail/' + article.id)">{{article.title}}</span>
							</div>
							<div class="mv5" v-if="article.type !== 'LINE_NEWS'">
								本文链接：<a :href="articleLink(article)" target="_blank">{{articleLink(article)}}</a>
							</div>
							<div class="mv5" v-if="article.type === 'LINE_NEWS'">
								目标地址：<a :href="article.content" target="_blank">{{article.content}}</a>
							</div>

							<div>
								<span class="mr10">#{{article.id}}</span>
								<span class="mr10">发布于:{{article.releaseTime | simpleDateTime}}</span>
								<span class="mr10">阅读:{{article.hit}}</span>
								<span class="mr10">作者:{{article.author}}</span>
							</div>

						</div>
					</div>
				</div>
			</div>

			<div class="col-xs-12 mt20">
				<div class="alert alert-info">
					本文链接中home可替换为相应专题地址，该链接可以在轮播图中关联，也可以在其他的文章正文中关联。
				</div>

			</div>

			<div class="col-xs-12 mt20">
				<NbPager :pager="pager" :callback="refresh"></NbPager>
			</div>

		</div>


	</div>

</template>
<script>

	import NbFilter from '../../../common/widget/filter/NbFilter.vue'
	import NbPager from '../../../common/widget/NbPager.vue'
	import {MessageBox, Notification} from 'element-ui'

	import Pager from  "../../../common/model/base/Pager"
	import Article from  "../../../common/model/article/Article"

	export default {

		data () {
			return {
				pager: new Pager(Article)
			}
		},
		components: {
			NbFilter,
			NbPager
		},
		computed: {
			host(){
				return window.location.protocol + "//" + window.location.host;
			},
			type(){
				let tempName = this.$store.state.route.params.type;
				if (tempName) {
					let TYPE = tempName.toUpperCase();
					if (Article.prototype.TypeMap[TYPE]) {
						return TYPE;
					}
				}
				return null;
			},
			name(){
				if (this.type) {
					return Article.prototype.TypeMap[this.type].name;
				} else {
					return "文章";
				}
			}
		},
		watch: {
			'$route' (to, from) {
				if (to.path !== from.path) {
					this.reset();
					this.refresh();
				}
			}
		},

		methods: {

			reset(){
				this.pager.page = 0;
				this.pager.resetFilter();
				this.pager.setFilter("type", this.type);
			},
			search(){
				this.name = null;
				this.pager.page = 0;
				this.refresh()
			},
			refresh(){
				this.pager.httpFastPage();
			},
			articleLink(article){

				let link = this.host;

				link += article.detailPageUrl();

				return link;

			},
			confirmDel(article){
				let that = this;
				MessageBox.confirm('此操作将永久删除该文章, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(function () {
						that.fetchDel(article);
					},
					function () {

					}
				);
			},
			fetchDel(article){

				let that = this;

				article.httpDel(function () {
					Notification.success({
						message: '成功删除文章!'
					});
					that.refresh();
				});
			}
		},
		mounted(){
			this.reset();
			this.pager.enableHistory();
			this.refresh();
		}
	}

</script>



// WEBPACK FOOTER //
// List.vue?23bbf2a0